import React from 'react';

const projectItems = [
    {
        title: 'Interactive Resume',
        description: [
            'A fully responsive personal website to showcase portfolio and resume',
            'Includes smooth navigation, form validation, and dynamic sections'
        ],
        technologies: ['HTML5', 'CSS3', 'JavaScript', 'React.js'],
        year: '2025',
        viewLink: '#',
        githubLink: '#'
    },
    {
        title: 'Expense Tracker',
        description: [
            'Built a dynamic application for adding, removing and vewing expense records',
            'Utilized React functional components and real-time updates'
        ],
        technologies: ['CSS3', 'JavaScript', 'React.js'],
        year: '2025',
        viewLink: '#',
        githubLink: '#'
    }
];

function MyProjects() {
    return (
        <section className='section' id='projects'>
            <h2>Projects</h2>
            <div className='project-grid'>
                {projectItems.map((project) => (
                    <article key={project.title} className='project-card'>
                        <h3>{project.title}</h3>
                        <ul className='project-description'>
                            {project.description.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                        <p className='project-meta'>
                            <strong>Year:</strong>
                            <span>{project.year}</span>
                        </p>
                        <div className='project-tech' aria-label='Technologies Used'>
                            {project.technologies.map((tech) => (
                                <span key={tech} className='tech-chip'>{tech}</span>
                            ))}
                        </div>
                        <div className='project-actions'>
                            <a className='project-btn' href={project.viewLink} target='_blank' rel='noreferrer'>
                                Live Demo
                            </a>
                            <a className='project-btn project-btn-alt' href={project.githubLink} target='_blank' rel='noreferrer'>
                                Source Code
                            </a>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}
export default MyProjects;
